module.exports = __webpack_public_path__ + "img/16.edb38ff1.png";